import { render } from "./BlckSecurityInfoSpan.vue?vue&type=template&id=3c6e2621&scoped=true"
const script = {}

import "./BlckSecurityInfoSpan.vue?vue&type=style&index=0&id=3c6e2621&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6e2621"]])

export default __exports__